function updateSectionVariant(currentUrl) {
  if(!currentUrl){
    currentUrl = window.location.href;
  }
  let cachedData = sessionStorage.getItem(currentUrl);
  
  if (cachedData) {
    updatePageContent(cachedData);
  } else {
    fetch(`${currentUrl}`)
    .then((response) => response.text())
    .then((responseText) => {
      sessionStorage.setItem(currentUrl, responseText);
      updatePageContent(responseText);
    })
    .catch((e) => {
      console.error(e);
    });
  }
}

function updatePageContent(responseText) {
  const html = new DOMParser().parseFromString(responseText, 'text/html');
  const selectors = ['.custom__option--select', '.product-form__container', '.product-form__hidden-inputs', '.product-form__hidden-selects']; // Ensure to add a dot (.) for class selector
  for (const selector of selectors) {
    const targetElement = document.querySelector(selector);
    const sourceElement = html.querySelector(selector);
    if (targetElement && sourceElement) {
      targetElement.replaceWith(sourceElement);
    }
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  let properties = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    (key.includes('properties[')) ? properties[key.replace("properties[",'').replace("]",'')] = formData.get(key) : obj[key] = formData.get(key);
  }
  if(Object.keys(properties).length > 0) obj.properties = properties;
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      window.pauseAllMedia();
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', (event) => {
      this.onVariantChange(event);
    });
    this.onLoadCheckVariantSubscriptValue();
    this.getInputValue();
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      // this.onVariantChange();
    });
  }

  getInputValue() {
    const swatchInputs = this.querySelectorAll('.variant-color-options .product-form__input-swatch');
    if (!swatchInputs) return;

    // uodate color title for first item on page load
    swatchInputs.forEach((item) => {
      if (item.classList.contains('active')) {
        const currentOptionValue = item.dataset.optionValue;
        const colorTitle = this.querySelector('.product-form__title-color-name');
        if (colorTitle) {
          colorTitle.innerHTML = currentOptionValue;
        }
      }
    })
  }

  onVariantChange() {
    this.updateOptions(event);
    this.updateMasterId();
    this.updatepreorderPolicy();
    if(this.currentVariant){
      this.hidesubscription();
    }
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.toggleSpecificOptionWithUrl();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.changeVariantImage();
      this.toggleSpecificOption();
    }
  }

  toggleSpecificOptionWithUrl() {
    let thisData = this;
    let checkedInput = thisData.querySelector('input[name="Color"]:checked');
    if(checkedInput){
      let variantScript = thisData.querySelector('.variantScript');
      if(variantScript) {
        const jsonData = variantScript.textContent;
        const variantData = JSON.parse(jsonData);
        let title = checkedInput.value;
        let foundVariant = variantData?.find(variant => variant?.option1 == title && variant?.option2?.toLowerCase()?.includes('three'));
        if(foundVariant){
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.set('variant', foundVariant.id);
          updateSectionVariant(currentUrl);
        }
      }
    }
  }

  toggleSpecificOption() {
    let thisData = this;
    let variantScript = thisData.querySelector('.variantScript');
      if(variantScript) {
        const jsonData = variantScript.textContent;
        const variantData = JSON.parse(jsonData);
        let foundVariant = variantData?.find(variant => variant?.option1?.toLowerCase()?.includes('three') || variant?.option2?.toLowerCase()?.includes('three'));
        if(foundVariant){
          const currentUrl = new URL(window.location.href);
          updateSectionVariant(currentUrl);
        }
      }
  }

  changeVariantImage() {
    if(this.currentVariant){
      if(this.currentVariant.featured_media){
        if(this.currentVariant.featured_media.position){
          var currVariant = this.currentVariant;
          setTimeout(function(){
            document.querySelectorAll(".product__slider-thumbnails-wrapper .product__slider-thumbnails > div")[parseInt(currVariant.featured_media.position) - 1].querySelector("img").click();
          },100)
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    if(this.options[1] == 'Single Unit' && this.options[0] != 'Three-Pack (One Unit Each of Stone/Aqua/Black)') {
    } else {
      this.options[1] = 'Three-Pack';
    }
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updatepreorderPolicy() {
  let varId = this?.currentVariant?.id,
      hiddenSeklectValue = document.querySelector(`.preorder-variant-policy[data-id="${varId}"]`);
      if(hiddenSeklectValue){
        let preorderValue = hiddenSeklectValue.getAttribute('data-preorder');
        let policyValue = hiddenSeklectValue.getAttribute('data-policy');
        if(preorderValue){
          this.atc_preorder = (preorderValue == 'true' && policyValue == 'continue');
        }
      }
  }
  
  hidesubscription() {
  let variantId = this.currentVariant.id,
      hiddenSubscription = document.querySelector(`.preorder-variant-policy[data-id="${variantId}"]`),
      SubscriptionValue = hiddenSubscription.getAttribute('data-hidesubscription'),
      findWidget = hiddenSubscription.closest('form').querySelector('.rtx-subscription')
    if(!findWidget) return
    let getSubscriptionOption = findWidget.querySelector('[for="purchaseTypeSubscription"]')

    if(SubscriptionValue == 'true'){
     if(getSubscriptionOption) getSubscriptionOption.style.display = 'none';
    }else{
     if(getSubscriptionOption) getSubscriptionOption.style.display = 'block';
    }   
  }

  onLoadCheckVariantSubscriptValue() {
    const findWidget = setInterval(ExicuteLogic, 1000);
    let FindFirstvariant = this.closest('form');
    function ExicuteLogic() {
        let findeInput = FindFirstvariant.querySelector('.hidesubscribe-load'),
        getMetaValue = findeInput.getAttribute('data-hidesubscription'),
        getSubscriptionOption = FindFirstvariant.querySelector('[for="purchaseTypeSubscription"]');
      //console.log('value:', getMetaValue)
      if(getSubscriptionOption){
      clearInterval(findWidget);

       if(getMetaValue == 'true'){
         if(getSubscriptionOption) getSubscriptionOption.style.display = 'none';
        }else{
         if(getSubscriptionOption) getSubscriptionOption.style.display = 'block';
        }
       }
      }    
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    // $('.product__media-list').slick('slickGoTo', $(newMedia).data('slickIndex'));

    // if (!newMedia) return;
    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // const parent = newMedia.parentElement;
    // if (parent.firstChild == newMedia) return;
    // modalContent.prepend(newMediaModal);
    // parent.prepend(newMedia);
    // this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    // this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    // window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const destination = document.getElementById(id);
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const source = html.getElementById(id);
        const variantMetafieldText = `#variant-meta-text--${this.dataset.section}`;

        // console.log("id: ",this.currentVariant);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        document.querySelector(variantMetafieldText).innerHTML = html.querySelector(variantMetafieldText).innerHTML;

        // shipping message update js start

          var currentVariantId = this.currentVariant.id;
          const selectElement = document.querySelector(".select__select[name='id']");
          if(selectElement != null){
            const optionsArray = Array.from(selectElement.options);
            optionsArray.forEach(function(optionLabel) {
              var optValue = Number(optionLabel.getAttribute("value"));
              if(optValue === currentVariantId){
                var shippingMsg = optionLabel.getAttribute("data-shipping-msg");
                if(document.querySelector(".product__shipping-message") != null){
                  if(shippingMsg != ''){
                    document.querySelector(".product__shipping-message").innerText = shippingMsg;
                  }else{
                    document.querySelector(".product__shipping-message").innerText = '';
                  }
                }
              }
            });
          }

        // shipping message update js end
        
      });
    
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = (this.atc_preorder) ? 'Pre-Order Now!' : window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions(event) {
    // update color title
    var relatedValues = document.querySelectorAll('.related_option_name');
    relatedValues.forEach((relatedVal) => {
      var relatedAttributeValue = relatedVal.getAttribute('data-option-name'); 
      var selectElement = $('.custom__option--select select');
      var triggerValue = relatedVal.value;
      if(relatedAttributeValue == event.target.value){
        selectElement.val(triggerValue).trigger('change');
        return false;
      }else if(event.target.value == triggerValue){
        return false;
      }else{
         selectElement.find('option').each(function() {
          var optionValue = $(this).val();
          if (optionValue != relatedAttributeValue) {
            console.log('optionValue',optionValue);
            // Use the first option value that does not match
            selectElement.val(optionValue).trigger('change');
            return false; // Exit the loop after finding the first unmatched value
          }
        });
      }
    });
    
    const colorTitle = this.querySelector('.product-form__title-color-name');
    if (event.target?.classList?.contains('variant-color-input')) {
      if (colorTitle) {
        colorTitle.innerHTML = event.target.value;
      }
    }

    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const allSwatches = fieldset.querySelectorAll('.product-form__input-swatch');
      // remove active class from all swatches
      allSwatches.forEach((item) => {
        if (item.classList.contains('active')) {
          item.classList.remove('active');
        }
      })
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class MegaMenuTabs extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll('.mega-menu-tabs__tab');
    this.tabs.forEach(tab => tab.addEventListener('click', this.handleTabClick.bind(this)));
  }

  handleTabClick() {
    event.preventDefault();
    const tab = event.currentTarget.dataset.tab;

    this.querySelector('.mega-menu-tabs__tab.active').classList.remove('active');
    event.currentTarget.classList.add('active');

    this.querySelector('.mega-menu-tabs__container.active').classList.remove('active');
    this.querySelector(`.mega-menu-tabs__container[data-tab="${tab}"]`).classList.add('active');

    this.querySelector(`.mega-menu-tabs__container[data-tab="${tab}"]`).parentElement.handleResize();
  }
}

customElements.define('mega-menu-tabs', MegaMenuTabs);

class MegaMenuTab extends MegaMenuTabs {
  constructor() {
    super();

    this.sliderWrapper = this.querySelector('.mega-menu-tabs__slider-wrapper');
    this.slider = this.querySelector('.mega-menu-tabs__slider');

    if (this.sliderWrapper) {
      this.next = this.querySelector('.mega-menu-tabs__button.next');
      this.next.addEventListener('click', this.onNext.bind(this));
      this.prev = this.querySelector('.mega-menu-tabs__button.prev');
      this.prev.addEventListener('click', this.onPrev.bind(this));

      this.handleResize();
      window.addEventListener('resize', event => {
        this.handleResize();
      });
    }
  }

  handleResize() {
    const width = this.slider.offsetWidth;

    if (width > window.innerWidth) {
      this.slider.classList.add('scroll');
    } else {
      this.slider.classList.remove('scroll');
      this.slider.classList.remove('scrolled');
    }
  }

  onNext() {
    this.sliderWrapper.scroll({
      top: 0,
      left: this.sliderWrapper.scrollLeft + 210,
      behavior: "smooth"
    });

    setTimeout(() => {
      this.slider.classList.add('scrolled');
    }, 200);
  }

  onPrev() {
    if (this.sliderWrapper.scrollLeft <= 0) {
      this.slider.classList.remove('scrolled');
    }

    this.sliderWrapper.scroll({
      top: 0,
      left: this.sliderWrapper.scrollLeft - 210,
      behavior: "smooth"
    });

    setTimeout(() => {
      if (this.sliderWrapper.scrollLeft <= 0) {
        this.slider.classList.remove('scrolled');
      }
    }, 200);
  }
}

customElements.define('mega-menu-tab', MegaMenuTab);

class LightBoxTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.openLightBox.bind(this));

    this.lightbox = document.querySelector('light-box.mp4');
  }

  openLightBox(event) {
    const url = event.currentTarget.dataset.video;
    this.lightbox.open(url);
  }
}

customElements.define('light-box-trigger', LightBoxTrigger);

class LightBox extends HTMLElement {
  constructor() {
    super();

    this.lightbox = this.querySelector('.lightbox');
    this.overlay = this.querySelector('.lightbox__overlay');
    this.video = this.querySelector('video');

    this.lightbox.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  open(url) {
    this.lightbox.setAttribute('aria-hidden', false);
    this.overlay.addEventListener('click', this.close.bind(this));

    if (url) {
      this.playVideo(url);
    }
  }

  close() {
    this.lightbox.setAttribute('aria-hidden', true);
    pauseAllMedia();
  }

  playVideo(url) {
    this.video.setAttribute('src', url);
    this.video.currentTime = 0;
    this.video.play();
  }
}

customElements.define('light-box', LightBox);

var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');

    this.slideButtons = document.querySelectorAll('.menu-drawer__menu-button--has-slide');
    this.closeSlideButtons = document.querySelectorAll('.menu-drawer__close-slide');
    
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.bindEvents();
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.open.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.close.bind(this)));

    this.slideButtons.forEach(slideBtn => slideBtn.addEventListener('click', this.slide.bind(this)));
    this.closeSlideButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeSlide.bind(this)));

    this.updateFromTop();
  }

  open() {
    this.updateFromTop();

    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    document.body.classList.add('scroll-lock');
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    document.body.classList.remove('scroll-lock');
  }

  updateFromTop() {
    const fromTop = document.querySelector('.announcement-bar').offsetHeight;
    this.drawer.style.top = `-${fromTop + 1}px`;
  }

  slide() {
    const secondaryMenu = event.target.tagName == 'SPAN'? event.target.parentNode.nextElementSibling : event.target.nextElementSibling;
    secondaryMenu.classList.add('active');
  }

  closeSlide() {
    const activeSlide = this.querySelector('.menu-drawer__secondary.active');
    activeSlide.classList.remove('active');
  }
}

customElements.define('menu-drawer', MenuDrawer);

/* ----- General Functions ----- */
// Add to cart
$('body').on('click', '.js-add-to-cart', function(e) {
  e.preventDefault();
  
  let id = Number($(this).data('id'));
  if (!id) {
    id = Number($(this).attr('variant'));
  }

  const body = JSON.stringify({
    items: [{
      id: id,
      quantity: 1
    }],
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          window.twitterEvent(parsedState.items[0]);
      }));
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
});

function getSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

// Cookies
function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}


/* ----- Sliders ----- */
// Product Slider
$('body:not(.template-product) .product-slider__group').slick({
  slidesToShow: 5,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 1550,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.product-slider__categories button').click(function() {
  const handle = $(this).data('handle');
  const $parentSlider = $(this).closest('.product-slider');

  $parentSlider.find('.product-slider__categories button').removeClass('active');
  $(this).addClass('active');

  $parentSlider.find('.product-slider__group').removeClass('active').removeClass('faded');
  $parentSlider.find(`.product-slider__group[data-handle="${handle}"]`).addClass('active');
  $parentSlider.find(`.product-slider__group[data-handle="${handle}"]`).slick('setPosition')

  setTimeout(function() {
	$parentSlider.find(`.product-slider__group[data-handle="${handle}"]`).addClass('faded');
  }, 300);
});

// Product Slider on PDP
$('.template-product .product-slider__group.active').slick({
  slidesToShow: 5,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 1550,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2,
      }
    }
  ]
});

$('.ingredients-info').slick({
  slidesToShow: 1,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
		arrows: false
      }
    }
  ]
});

$('.ingredients-info-new').slick({
  slidesToShow: 1,
  arrows: false,

  responsive: [
    {
      breakpoint: 768,
      settings: {
		
      }
    }
  ]
});

// what's included
// Product Slider Upsell
$('body:not(.template-product) .product-slider__group-included').slick({
  slidesToShow: 3,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1997_581)"><path d="M22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44Z" fill="#E2DCD5"/><path d="M24 18L20 22L24 26" stroke="black" stroke-width="2" stroke-linecap="square"/></g><defs><clipPath id="clip0_1997_581"><rect width="44" height="44" fill="white"/></clipPath></defs></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1997_584)"><path d="M22 1.9233e-06C34.1503 2.98551e-06 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 8.61091e-07 34.1503 1.9233e-06 22C2.98551e-06 9.84974 9.84974 8.61091e-07 22 1.9233e-06Z" fill="#E2DCD5"/><path d="M20 26L24 22L20 18" stroke="black" stroke-width="2" stroke-linecap="square"/></g><defs><clipPath id="clip0_1997_584"><rect width="44" height="44" fill="white" transform="translate(44 44) rotate(-180)"/></clipPath></defs></svg></button>',
  responsive: [
    {
      breakpoint: 1750,
      settings: {
        arrows: true,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 1550,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 1050,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        arrows: true
      }
    }
  ]
});

$('.ingredients-info').on('afterChange', function(event, slick, currentSlide, nextSlide){
  console.log(currentSlide);
  $('.ingredients-slider__titles p').removeClass('active');
  $(`.ingredients-slider__titles p[data-id='${currentSlide}']`).addClass('active');
});

$('.ingredients-info-new').on('afterChange', function(event, slick, currentSlide, nextSlide){
  console.log(currentSlide);
  $('.ingredients-slider__titles p').removeClass('active');
  $(`.ingredients-slider__titles p[data-id='${currentSlide}']`).addClass('active');
});

$('.ingredients-slider__titles p').click(function(e) {
  e.preventDefault();
  $('.ingredients-slider__titles p').removeClass('active')
  $(this).addClass('active');
  var slideno = $(this).data('id');
  $('.ingredients-info').slick('slickGoTo', slideno);
});

$('.ingredients-slider__titles p').click(function(e) {
  e.preventDefault();
  $('.ingredients-slider__titles p').removeClass('active')
  $(this).addClass('active');
  var slideno = $(this).data('id');
  $('.ingredients-info-new').slick('slickGoTo', slideno);
});



$('.how-to-use__categories button').click(function() {
  const handle = $(this).data('handle');
  const $parentSlider = $(this).closest('.how-to-use-slider');

  $parentSlider.find('.how-to-use__categories button').removeClass('active');
  $(this).addClass('active');

  $parentSlider.find('.how-to-use__group').removeClass('active');
  $parentSlider.find(`.how-to-use__group[data-handle="${handle}"]`).addClass('active');
});



// Featured products slider
$('.featured-products__media').slick({
  arrows: false,
  dots: true,
  asNavFor: '.featured-products__content'
});

$('.featured-products__content').slick({
  asNavFor: '.featured-products__media',
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        adaptiveHeight: true
      }
    }
  ]
});

// Testimonial slider
$('.testimonial-slider__container').slick({
  arrows: false,
  dots: true,
  autoplay: true
});

$('.testimonial-slider__container-new').slick({
   arrows: true,
   dots: false,
   autoplay: false,
   prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
   nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 685,
      settings: {
		appendArrows: $('.mobile-arrow__anchor')
      }
    }
  ]
});

$('.testimonials-slider-2__container').slick({
  arrows: true,
  dots: true,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
 responsive: [
   {
     breakpoint: 768,
     settings: {
   appendArrows: $('.testimonials-slider-2__arrows')
     }
   }
 ],
 autoplay: true
});

$('.testimonial-paid').slick({
   arrows: true,
   dots: false,
   autoplay: false,
   slidesToShow: 3,
   slidesToScroll: 1,
   prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
   nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 951,
      settings: {
        slidesToShow: 1
      }
    },
    {
      breakpoint: 685,
      settings: {
        slidesToShow: 1,
		appendArrows: $('.mobile-arrow__anchor')
      }
    }
  ]
});

// Blog slider
$('.blog-slider__container').slick({
  infinite: false,
  variableWidth: true,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        variableWidth: false
      }
    }
  ]
});

/* ----- Dropdowns ----- */
// Benefits dropdowns
$('.benefits__dropdown-header').click(function() {
  $(this).parent().toggleClass('active');
  $(this).siblings('.benefits__dropdown-content').slideToggle(300);
});

/* PDP Slider */
$('.product__media-list').slick({
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 1050,
      settings: {
      }
    },
    {
      breakpoint: 768,
      settings: {
        useTransform: false,
        arrows: true,
        dots: true,
        prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
      }
    }
  ]
});

// Sync thumbnails with slider
$('.product__media-list').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var slide = nextSlide;
  var mediaId = $(`.product__media-item[data-slick-index="${slide}"]`).data('mediaId');
  $('.product__slider-thumbnail-item').removeClass('active');
  $(`.product__slider-thumbnail-item[data-media-id="${mediaId}"]`).addClass('active');
});

// Sync slider with thumbnails
$('.product__slider-thumbnail-item').on('click', function() {
  var slide = $(this).data('mediaId');

  $('.product__slider-thumbnail-item').removeClass('active');
  $(this).addClass('active');

  var slidePosition = $(`.product__media-item[data-media-id="${slide}"]`).data('slickIndex');
  console.log($('.product__media-list'))
  $('.product__media-list').slick('slickGoTo', slidePosition);
});

/* Product breakdown slider */
$('.product-breakdown__slider').slick({
  arrows: false,
  responsive: [
    {
      breakpoint: 1050,
      settings: {
        useTransform: false,
        dots: false
      }
    }
  ]
});

// Sync bullets with slider
$('.product-breakdown__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  var slide = nextSlide;

  $('.product-breakdown__image-bullet').removeClass('active');
  $(`.product-breakdown__image-bullet[data-count="${slide}"]`).addClass('active');
  $('.product-breakdown-new__titles p').removeClass('active');
  $(`.product-breakdown-new__titles p[data-id="${Number(slide + 1)}"]`).addClass('active');
});

// Sync slider with bullets
$('.product-breakdown__image-bullet').click(function() {
  var slide = $(this).data('count');

  $('.product-breakdown__image-bullet').removeClass('active');
  $(this).addClass('active');

  $('.product-breakdown__slider').slick('slickGoTo', slide);
});

$('.product-breakdown-new__titles p').click(function() {
  var slide = Number($(this).data('id')) -1;

  $('.product-breakdown__slider').slick('slickGoTo', slide);
});

$('.product-breakdown__left .product-breakdown__item .product-breakdown__title').click(function() {
    let id = $(this).parent().data("id")

    $('.product-breakdown__left .product-breakdown__item .product-breakdown__title').removeClass('active')
    $(this).addClass('active')
    $('.product-breakdown__left .product-breakdown__item svg').hide()
    $('.product-breakdown__right .product-breakdown__item').hide()
    $(`.product-breakdown__right .product-breakdown__item[data-id='${id}']`).fadeIn()
    $(`.product-breakdown__left .product-breakdown__item[data-id='${id}'] svg`).fadeIn()
})

/* Product how to use slider */
$('.how-to-use__slider').slick({
  arrows: false,
  responsive: [
    {
      breakpoint: 1050,
      settings: {
        useTransform: false,
        dots: true
      }
    }
  ]
});


/* Benefits mobile slider */
$benefitsSlider = $('.benefits__dropdowns.mobile-slider');
settingsSlider = {
  dots: false,
  arrows: false
}

slickOnMobile($benefitsSlider, settingsSlider);

// Slick on mobile
function slickOnMobile(slider, settings){
  $(window).on('load resize', function() {
    if ($(window).width() > 768) {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
      }
      return
    }
    if (!slider.hasClass('slick-initialized')) {
      return slider.slick(settings);
    }
  });
};

// Blog Watch Slider
$blogWatchSlider = $('.main-blog__watch-articles');
var blogSettingsSlider = {
  variableWidth: true,
  arrows: false
}

slickOnMobile($blogWatchSlider, blogSettingsSlider);
 
// Location detail page
if($(window).innerWidth() <= 767) {
  var allPanels = $('.loc-details .image-with-text__text').hide();    
  $('.loc-details .image-with-text__heading').click(function() {
    allPanels.slideUp();
    $(this).next().toggle();

   $(this).toggleClass('accordion-toggled');
      $('.loc-details > h2').not(this).removeClass('accordion-toggled');
  });
} 
else {

}

//Announcement bar
$('.announcement-bar.announcement-slider').slick({
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 3000,
  fade: true,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 1.5L1 5.5L5 9.5" stroke="white" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1.5L5 5.5L1 9.5" stroke="white" stroke-linecap="square"/></svg></button>',
});

// Animations
var fadeInUps = gsap.utils.toArray('.fade-in-up');

fadeInUps.forEach((fadeInUp) => {
  gsap.from(fadeInUp, { 
    opacity: 0,
    y: 20,
    duration: .6,
    scrollTrigger: {
      trigger: fadeInUp,
      start: "top 80%"
    }
  })
});


// benefits

$('.benefits-new__titles.benefits-menu p').click(function() {
  let id = $(this).data('id')

  $('.benefits-new__titles.benefits-menu p').removeClass('active')
  $(this).addClass('active')
  $('.benefits-new__ind').hide()
  $(`.benefits-new__ind[data-id='${id}']`).css("display", "flex").hide().fadeIn();
})

$('.sale-hover').click(function() {
  $('.discount-text__tooltip').toggle()
})

// services

$('.location-info__drophead').click(function() {
  $(this).next().slideToggle()
  $(this).find('.plus').toggle()
  $(this).find('.minus').toggle() 
})

$('.location-info__links p').click(function() {
  let scrollSection = $(this).data('section');
  
  $('.location-info__links p').css({'opacity': 0.3, 'color': 'black'})
  $(this).css({'opacity': 1, 'color': '#06CCE8'})

  
  console.log(scrollSection)


  if (scrollSection == 'pricing') {
    $([document.documentElement, document.body]).animate({ 
      scrollTop: $(`.location-info__drophead[data-section='${scrollSection}']`).offset().top -100
    }, 1000);
  } else if (scrollSection == 'partners') {
    $([document.documentElement, document.body]).animate({ 
      scrollTop: $(`.text-section__container[data-section='${scrollSection}']`).offset().top - 100
    }, 1000);
  } else if (scrollSection == 'spa-gift-cards') {
    $([document.documentElement, document.body]).animate({ 
      scrollTop: $(`.mind-body[data-section='${scrollSection}']`).offset().top - 100
    }, 1000);
  } else {
    $([document.documentElement, document.body]).animate({ 
      scrollTop: $(`.info-flex[data-section='${scrollSection}']`).offset().top -100
    }, 1000);
  }

  if (scrollSection == 'partners') {
    $([document.documentElement, document.body]).animate({ 
      scrollTop: $(`.text-section__container[data-section='${scrollSection}']`).offset().top -100
    }, 1000);
  } else {
    $([document.documentElement, document.body]).animate({ 
      scrollTop: $(`.info-flex[data-section='${scrollSection}']`).offset().top -100
    }, 1000);
  }

})

$('.services-info strong').click(function() {
    $([document.documentElement, document.body]).animate({ 
      scrollTop: $(`#services-information`).offset().top -100
    }, 2000);
})


$(window).on( 'scroll', function(){
  if(!!$('.sticky-bar__container').offset()) {
  var top     = $(window).scrollTop() + $('.header-wrapper').height() + $('.announcement-bar').height() + 14,
      elementOffset = $('.sticky-bar__container').offset().top,
      distance      = (elementOffset - top);

    if(distance >= 0) {
       $('.sticky-bar__container-sticky').hide()
    } else {
      $('.sticky-bar__container-sticky').css('display', 'flex')
    }
  }
});

$('.how-to-use__paid .how-to-use-paid__slider').slick({
  arrows: false,
  dots: false,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 1050,
      settings: {
        useTransform: false,
        dots: false,
        arrows: true,
        swipeToSlide: true,
        appendArrows: $('.how-to-mobile-arrow__anchor')
      }
    }
  ]
});

// best selling slider


$('.best-selling__media').slick({
  arrows: false,
  dots: false
});

$('.best-selling__titles p').click(function() {

  let slideNum = $(this).data('id')
  $('.best-selling__titles p').removeClass('active')
  $(this).addClass('active')
  $('.best-selling__media').slick('slickGoTo', slideNum);
  $('.best-selling__content').hide()
  $(`.best-selling__content[data-id="${slideNum}"]`).fadeIn()
})


$('.benefits-slider__container .benefits-new__body').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  initialSlide: -1,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        dots: false,
        swipeToSlide: true,
        slidesToShow: 1,
        initialSlide: 0,
      }
    }
  ]
  
});

$(document).ready(function() {
  if ($(window).width() > 768){
    $(`.benefits-slider__container .benefits-new__ind[data-slick-index='0']`).addClass('active') 
  } else {
    $(`.benefits-slider__container .benefits-new__ind`).addClass('active') 
  }
})

$('.benefits-slider__container .benefits-new__titles p').click(function() {
  $('.benefits-slider__container .benefits-new__titles p').removeClass('active')
  $(this).addClass('active')
  let slideNum;
  if ($(window).width() > 768){
   slideNum = $(this).data('id') - 2;
    $('.benefits-slider__container .benefits-new__body').slick('slickGoTo', slideNum);
   $(`.benefits-slider__container .benefits-new__ind`).removeClass('active')
   $(`.benefits-slider__container .benefits-new__ind.slick-current`).next().addClass('active') 
  } else {
   slideNum = $(this).data('id') - 1;
    $('.benefits-slider__container .benefits-new__body').slick('slickGoTo', slideNum);
   $(`.benefits-slider__container .benefits-new__ind`).addClass('active') 
  }
   
})

$.fn.digits = function(){ 
    return this.each(function(){ 
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") ); 
    })
}

$(document).ready(function() {
  if(!$('body').hasClass('template-customers')){
    $('a[href^="#"]').click(function(event) {
      var id = $(this).attr("href");
      var offset = 40;
      var target = $(id).offset().top - offset;
      $('html, body').animate({scrollTop:target}, 500);
      event.preventDefault();
    });
  }

  let title = $('.product-grouped .product-form input:checked').data('title');
  if(!!title) { 
    $('.product-bar__form-container-form .body-1').text(`${title}`)
  }
                  
  let price = $('.product-grouped .product-form input:checked').data('price')/100
  if (!!price){
    $('.product-bar__form-container-form .product-form__submit').html(`Add to cart &nbsp;&nbsp;•&nbsp;&nbsp; $${price}`).digits()
  }
  
  let id = $('.product-grouped .product-form input:checked').data('grouped');
  if (!!id) {
    $('.product-bar__form-container-form input[name="id"]').val(`${id}`)
  }
});

// Code added by Team Galactic Fed
$(".quoteLoop > div:gt(0)").hide();

setInterval(function() { 
  $('.quoteLoop > div:first')
  .fadeOut(500)
  .next()
  .delay(500)
  .fadeIn(500)
  .end()
  .appendTo('.quoteLoop');
}, 5000);
// End code added by Team Galactic Fed


$('.grouped-atc').click(function(e) {
  e.preventDefault();
  
  let id = Number($('.product-grouped .product-form input:checked').data('grouped'));

  const body = JSON.stringify({
    items: [{
      id: id,
      quantity: 1
    }],
    sections: getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname
  });

  fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      getSectionsToRender().forEach((section => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

        elementToReplace.innerHTML =
          getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));
      window.twitterEvent(parsedState.items[0]);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      document.querySelector('cart-drawer').open();
    });
})


$('.product-grouped .product-form input').click(function(e) {
  console.log($(this).data('title'))
  let title = $(this).data('title')
  let id = $(this).data('grouped')
  let price = $(this).data('price')/100
  $('.product-bar__form-container-form .body-1').text(`${title}`)
  $('.product-bar__form-container-form input[name="id"]').val(`${id}`)
  $('.product-bar__form-container-form .product-form__submit').html(`Add to cart &nbsp;&nbsp;•&nbsp;&nbsp; $${price}`).digits()
})

// Image slideshow
$('.image-slideshow__slider').slick({
  appendArrows: $('.image-slideshow__arrows'),
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: '<button type="button" class="slick-prev"><span class="visually-hidden">prev</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle r="22" transform="matrix(-1 0 0 1 22 22)" fill="#007D8A"/><path d="M24 18L20 22L24 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><span class="visually-hidden">next</span><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none"><circle cx="22" cy="22" r="22" fill="#007D8A"/><path d="M20 18L24 22L20 26" stroke="white" stroke-width="2" stroke-linecap="square"/></svg></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
  ]
});

function playVideo(modal) {
  let video = modal.querySelector("video")
  if(video){
    video.play()
    video.nextElementSibling.style.display = "none"
  }
}

function stopVideo(modal) {
  let video = modal.querySelector("video")
  if(video){
    video.pause()
    video.currentTime = 0
    video.nextElementSibling.removeAttribute("style")
  }

  let iframe = document.getElementById('youtube-video');
  if(iframe) {
    let iframeSrc = iframe.src;
    iframe.src = iframeSrc; // Reloads the iframe to stop the video
  }
}

/*================ Micromodal ================*/
MicroModal.init({
  openClass: 'is-open',
  disableScroll: true,
  onShow: modal => playVideo(modal),
  onClose: modal => stopVideo(modal),
});

class QuickView extends HTMLElement {
  constructor() {
    super();

    this.quickView = this;
    this.quickViewContent = this.querySelector('.quick-view__content');

    document.body.addEventListener('click', event => {
      if (event.target.closest('.product-card__quick-view')) {
        this.open(event.target.closest('.product-card__quick-view'));
      }
    });
    this.buttons = document.querySelectorAll('.product-card__quick-view');
    // this.buttons.forEach(button => {
    //   button.addEventListener('click', this.open.bind(this));
    // });

    this.closeButtons = this.querySelectorAll('.quick-view__close');
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.close.bind(this));
    });
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  close() {
    this.quickView.setAttribute('aria-hidden', true);
    setTimeout(() => {
      this.quickViewContent.innerHTML = '';
    }, 350);
  }

  open(event) {
    const opener = event.currentTarget || event;
    opener.classList.add('loading');
    opener.querySelector('.loading-overlay').classList.remove('hidden');

    fetch(`${opener.dataset.productUrl}?section_id=main-product-quickview`)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('.product-quickview-content');
        this.quickViewContent.innerHTML = this.productElement.innerHTML;

        $('.quick-view .product__media-list').slick({
          arrows: false,
          responsive: [
            {
              breakpoint: 1050,
              settings: {
                dots: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                useTransform: false,
                dots: false
              }
            }
          ]
        });

        // Sync thumbnails with slider
        $('.quick-view .product__media-list').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var slide = nextSlide;
          var mediaId = $(`.quick-view .product__media-item[data-slick-index="${slide}"]`).data('mediaId');
          $('.quick-view .product__slider-thumbnail-item').removeClass('active');
          $(`.quick-view .product__slider-thumbnail-item[data-media-id="${mediaId}"]`).addClass('active');
        });

        // Sync slider with thumbnails
        $('.quick-view .product__slider-thumbnail-item').on('click', function() {
          var slide = $(this).data('mediaId');

          $('.quick-view .product__slider-thumbnail-item').removeClass('active');
          $(this).addClass('active');

          var slidePosition = $(`.quick-view .product__media-item[data-media-id="${slide}"]`).data('slickIndex');
          $('.quick-view .product__media-list').slick('slickGoTo', slidePosition);
        });

        $('.quick-view .product__description-toggle-control').click(function() {
          $('.quick-view .product__description--short').toggle();
          $('.quick-view .product__description--long').toggle();
          $(this).hide();
        });
      
        $('.quick-view .product__dropdown-header').click(function() {
          $(this).toggleClass('active');
          $(this).siblings('.quick-view .product__dropdown-content').slideToggle(300);
        });

        setTimeout(() => {
          this.quickView.setAttribute('aria-hidden', false);
        }, 150);

        this.preventVariantURLSwitching();
      })
      .finally(() => {
        // this.querySelector('.product-form__submit').addEventListener('click', event => {
        //   if (!event.target.disabled) {
        //     this.close();
        //   }
        // });
        
        opener.classList.remove('loading');
        opener.querySelector('.loading-overlay').classList.add('hidden');
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventVariantURLSwitching() {
    this.quickViewContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
  }

  removeDOMElements() {
    const pickupAvailability = this.productElement.querySelector('pickup-availability');
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = this.productElement.querySelector('product-modal');
    if (productModal) productModal.remove();
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
    this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
      variantSelect.dataset.originalSection = sectionId;
    });
  }

  removeGalleryListSemantic() {
    const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
    if (!galleryList) return;

    galleryList.setAttribute('role', 'presentation');
    galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
  }
}

customElements.define('quick-view', QuickView);

function playVideo(modal) {
  let video = modal.querySelector("video")
  if(video){
    video.play()
    video.nextElementSibling.style.display = "none"
  }
}

function stopVideo(modal) {
  let video = modal.querySelector("video")
  if(video){
    video.pause()
    video.currentTime = 0
    video.nextElementSibling.removeAttribute("style")
  }

  let iframe = document.getElementById('youtube-video');
  if(iframe) {
    let iframeSrc = iframe.src;
    iframe.src = iframeSrc; // Reloads the iframe to stop the video
  }
}

/*================ Micromodal ================*/
MicroModal.init({
  openClass: 'is-open',
  disableScroll: true,
  onShow: modal => playVideo(modal),
  onClose: modal => stopVideo(modal),
  awaitOpenAnimation: true,
});

// Product modal

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
  customElements.define('modal-opener', ModalOpener);


// Nav Scroll For Glossary page
function navScroll() {
  const navLinks = document.querySelectorAll('.glossary__nav-link');

  const glossaryNav = document.querySelector('.glossary__nav');
  if (glossaryNav) {
    glossaryNav.parentElement.style.position = 'sticky';
    glossaryNav.parentElement.style.top = '60px';
  }

  if (!navLinks) return;
  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (event) => {
      event.preventDefault();

      const targetId = navLink.getAttribute('href');
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        const offset = 178;
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

        setTimeout(() => {
          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }, 200);
      }
    });
  });
}

navScroll();